import ReportIntro from '@app/components/reports/components/report-intro';
import { useCCFReportResult } from '../ccf-report-result-context';

export default function CCFReportIntro() {
  const { result, downloadMode } = useCCFReportResult();

  return (
    <ReportIntro
      result={result}
      downloadMode={downloadMode}
      locationHash="#introduction"
      reportType="ccf"
    />
  );
}
